import WhyInvest from './WhyInvest';
export default WhyInvest;
